import { FC } from 'react';
import { Grid, Text } from '@mantine/core';
import Subtitle from 'components/Subtitle';
import FieldText from './FieldText';

const ContactInfo: FC = () => {
    return (
        <>
            <Subtitle title="Yhteystiedot" />
            <Grid gutter="md">
                <Grid.Col span={{ base: 12, sm: 6 }}>
                    <FieldText name="etunimi" title="Etunimi" required />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6 }}>
                    <FieldText name="sukunimi" title="Sukunimi" required />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6 }}>
                    <FieldText name="nickname" title="Nimimerkki" required />
                </Grid.Col>
                <Grid.Col span={{ base: 12, sm: 6 }}>
                    <FieldText name="steamId" title="SteamID" placeholder={'76561198005488744'} />
                </Grid.Col>
                <Grid.Col span={12}>
                    <Text>
                        SteamID:n selvität helposti vaikkapa osoitteessa{' '}
                        <a href={'https://www.steamidfinder.com/'} target={'_blank'} rel={'noreferrer'}>
                            https://www.steamidfinder.com/
                        </a>
                    </Text>
                </Grid.Col>
                <Grid.Col span={12}>
                    <FieldText name="puhelin" title="Puhelinnumero" required />
                </Grid.Col>
                <Grid.Col span={12}>
                    <FieldText name="email" title="Sähköposti" required />
                </Grid.Col>
            </Grid>
        </>
    );
};

export default ContactInfo;
